import React from 'react';
import { useTranslation } from 'react-i18next';
import './TargetingCancelDialog.css';
import getWeaponTargetingMessage from '../targeting/getWeaponTargetingMessage';
import { getStrategemTargetingPrompt } from '../targeting/getTargetingMessage';

const TargetingCancelDialog = ({
  deployMode,
  strategemMode,
  weaponMode,
  weaponDeployMode,
  weaponDeployTargetInfo,
  droneMode,
  euEpZoneMode,
  euEpTargetMode,
  strategemTargetInfo,
  selectedDeployOrderId,
  deployTargetInfo,
  /** Localized card name from GET /order/:id?lang=… when available */
  deployOrderDisplayName,
  strategemOrderDisplayName,
  weaponOrderDisplayName,
  droneOrderDisplayName,
  onCancelDeploy,
  onCancelStrategem,
  onCancelWeapon,
  onCancelWeaponDeploy,
  onCancelDrone,
  onCancelEuEpZone,
  onCancelEuEpTarget,
}) => {
  const { t } = useTranslation();
  
  // Don't render if no mode is active
  if (!deployMode && !strategemMode && !weaponMode && !weaponDeployMode && !droneMode && !euEpZoneMode && !euEpTargetMode) {
    return null;
  }

  // Unit 349 (Enhanced Scorpion) requires mandatory targeting - cannot cancel
  const isMandatoryTargeting = selectedDeployOrderId === 349;

  return (
    <div className="targeting-cancel-dialog">
      {deployMode && (
        <div className="targeting-message">
          {t('battleUI.selectTargetForDeployNamed', {
            name:
              (typeof deployOrderDisplayName === 'string' && deployOrderDisplayName.trim()) ||
              deployTargetInfo?.order?.name ||
              t('battleUI.deployTargetingFallbackUnit')
          })}
          {!isMandatoryTargeting && (
            <button 
              onClick={onCancelDeploy}
              className="cancel-button"
            >
              {t('battleUI.cancelTargeting')}
            </button>
          )}
          {isMandatoryTargeting && (
            <span className="mandatory-targeting-note" style={{ marginLeft: '10px', color: '#ff6b6b', fontSize: '0.9em' }}>
              {t('battleUI.mandatoryDeployTargetingNote')}
            </span>
          )}
        </div>
      )}
      
      {strategemMode && (
        <div className="targeting-message">
          {getStrategemTargetingPrompt(strategemTargetInfo, {
            displayName: strategemOrderDisplayName
          })}
          {typeof document !== 'undefined' && document.body?.getAttribute('data-tutorial-overlay-disable-cancel-targeting') !== 'true' && (
            <button 
              onClick={onCancelStrategem}
              className="cancel-button"
            >
              {t('battleUI.cancelTargeting')}
            </button>
          )}
          {typeof document !== 'undefined' && document.body?.getAttribute('data-tutorial-overlay-disable-cancel-targeting') === 'true' && (
            <span className="mandatory-targeting-note" style={{ marginLeft: '10px', color: '#aaa', fontSize: '0.9em' }}>
              {t('battleUI.tutorialSelectIndicatedTargetNote')}
            </span>
          )}
        </div>
      )}

      {weaponMode && (
        <div className="targeting-message">
          {typeof weaponOrderDisplayName === 'string' && weaponOrderDisplayName.trim()
            ? t('battleUI.weaponAttachTargetingBannerNamed', { name: weaponOrderDisplayName.trim() })
            : t('battleUI.weaponAttachTargetingBanner')}
          <button 
            onClick={onCancelWeapon}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {weaponDeployMode && (
        <div className="targeting-message">
          {getWeaponTargetingMessage(weaponDeployTargetInfo?.weaponId)}
          <button 
            onClick={onCancelWeaponDeploy}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {droneMode && (
        <div className="targeting-message">
          {typeof droneOrderDisplayName === 'string' && droneOrderDisplayName.trim()
            ? t('battleUI.droneTargetingBannerNamed', { name: droneOrderDisplayName.trim() })
            : t('battleUI.droneTargetingBanner')}
          <button 
            onClick={onCancelDrone}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {euEpZoneMode && (
        <div className="targeting-message">
          {t('exploreUnknownBattle.epZoneSelectZonePrompt')}
          <button
            type="button"
            onClick={onCancelEuEpZone}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}

      {euEpTargetMode && (
        <div className="targeting-message">
          {t('exploreUnknownBattle.epTargetSelectUnitPrompt')}
          <button
            type="button"
            onClick={onCancelEuEpTarget}
            className="cancel-button"
          >
            {t('battleUI.cancelTargeting')}
          </button>
        </div>
      )}
    </div>
  );
};

export default TargetingCancelDialog;
